module.exports = __webpack_public_path__ + "img/desc4.15369d47.png";